module.exports = __webpack_public_path__ + "static/media/marmalade-bbi-logo.eda3e5ea.svg";